/**
 * @generated SignedSource<<c5eaeb78e3b89d63a8dbdab7ab9a5a84>>
 * @relayHash 11fc70549ecffc4e4357e863934125f1
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-trade/567.0.0-2026-07-09T16:56:40.805Z/useFetchDesignProjectPhotosQuery

import { ConcreteRequest } from 'relay-runtime';
export type useFetchDesignProjectPhotosQuery$variables = {
  projectRootId: string;
};
export type useFetchDesignProjectPhotosQuery$data = {
  readonly viewer: {
    readonly designProjectRootSearch: {
      readonly tradePhotos: ReadonlyArray<{
        readonly height: number | null;
        readonly name: string | null;
        readonly path: string | null;
        readonly serviceId: string | null;
        readonly url: string | null;
        readonly width: number | null;
      } | null> | null;
    } | null;
  };
};
export type useFetchDesignProjectPhotosQuery = {
  response: useFetchDesignProjectPhotosQuery$data;
  variables: useFetchDesignProjectPhotosQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectRootId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "projectRootId",
    "variableName": "projectRootId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useFetchDesignProjectPhotosQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*:: as any*/),
            "concreteType": "DesignProjectRootSearchResult",
            "kind": "LinkedField",
            "name": "designProjectRootSearch",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TradePhoto",
                "kind": "LinkedField",
                "name": "tradePhotos",
                "plural": true,
                "selections": [
                  (v2/*:: as any*/),
                  (v3/*:: as any*/),
                  (v4/*:: as any*/),
                  (v5/*:: as any*/),
                  (v6/*:: as any*/),
                  (v7/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useFetchDesignProjectPhotosQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*:: as any*/),
            "concreteType": "DesignProjectRootSearchResult",
            "kind": "LinkedField",
            "name": "designProjectRootSearch",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TradePhoto",
                "kind": "LinkedField",
                "name": "tradePhotos",
                "plural": true,
                "selections": [
                  (v2/*:: as any*/),
                  (v3/*:: as any*/),
                  (v4/*:: as any*/),
                  (v5/*:: as any*/),
                  (v6/*:: as any*/),
                  (v7/*:: as any*/),
                  (v8/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v8/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-trade/567.0.0-2026-07-09T16:56:40.805Z/useFetchDesignProjectPhotosQuery",
    "metadata": {},
    "name": "useFetchDesignProjectPhotosQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "73ac6ad0c6910f3b7d8d39edb9b1d6d0";

export default node;
